import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-site-footer',
  templateUrl: './site-footer.component.html',
  styleUrls: ['./site-footer.component.scss'],
  preserveWhitespaces: false
})
export class SiteFooterComponent implements OnInit {
  currentYear: any;

  constructor() { }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
  }

}



// WEBPACK FOOTER //
// /app/src/app/layouts/site-footer/site-footer.component.ts